@if (themeName === 'db') {
  <app-header-db />
}
@if (themeName === 'pb') {
  <app-header-pb />
}
@if (themeName === 'nb') {
  <app-header-nb class="m-0" />
}

<div class="container {{getAppThemeName() + '-bg-color'}}">
    <router-outlet />
</div>

<db-footer></db-footer>

<ng-template #modalTemplate>
    <db-modal-header-default title="{{'GLOBAL.inactivity_warning' | translate}}" />
    <db-modal-content-default>
        <p>{{'GLOBAL.time_remaining' | translate}}: <b><i>{{formatSeconds(sessionTimer.graceTimeLeft$ |
                    async)}}s</i></b></p>
    </db-modal-content-default>
</ng-template>
